import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M4.39 2c-.64 0-1.53.6-2.09 1.12C1.91 3.48 1 4.42 1 5.4c0 1.51.43 3.11 1.27 4.76.78 1.52 1.89 3.03 3.21 4.36 1.33 1.33 2.83 2.44 4.36 3.21 1.65.84 3.25 1.27 4.76 1.27.98 0 1.92-.91 2.28-1.31.52-.56 1.12-1.45 1.12-2.09 0-.32-.21-.69-.66-1.18-.34-.36-.79-.77-1.31-1.18-.32-.25-1.93-1.47-2.71-1.47-.64 0-1.08.72-1.54 1.48-.18.29-.37.6-.54.82-.19.24-.29.28-.31.28-2.01-.81-4.48-3.27-5.29-5.28.01-.02.05-.12.28-.31.22-.17.52-.36.82-.54.76-.47 1.48-.91 1.48-1.55 0-.77-1.23-2.39-1.47-2.7-.41-.52-.82-.98-1.18-1.31C5.08 2.21 4.71 2 4.39 2z',
  ],
  height: 20,
  width: 20,
});
